import React, { useId, useMemo } from 'react';
import debounce from 'debounce';

export default function InputField(props) {
    const {
        label = '',
        placeholder = '',
        type,
        inputRef,
        onChange,
        required = false,
        hideLabel = true,
        autoFocus = false,
        children,
    } = props;


    const reactId = useId();
    const baseId = useMemo(() => {
        const slug = String(label || 'input').toLowerCase().replace(/\s+/g, '_');
        return `${slug}-${reactId.replace(/:/g, '')}`;
    }, [label, reactId]);

    const inputId = `${baseId}-field`;
    const labelId = `${baseId}-label`;

    const placeholderText = `${placeholder ? placeholder : label}${required ? ' *' : ''}`;

    const hiddenStyles = {
        position: 'absolute',
        width: 1,
        height: 1,
        padding: 0,
        border: 0,
        margin: -1,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        whiteSpace: 'nowrap',
    };

    const inputStyles = {
        fontFamily: 'SourceSansPro, sans-serif',
        border: '1px solid #000',
        fontSize: 16,
        lineHeight: 1.25,
        padding: '8px 15px',
        marginBottom: 15,
        marginTop: 15,
        width: '100%',
        boxSizing: 'border-box',
    };

    return (
        <>
            <label id={labelId} htmlFor={inputId} style={hideLabel ? hiddenStyles : null}>{label}</label>

            <input
                id={inputId}
                type={type}
                ref={inputRef}
                style={inputStyles}
                placeholder={placeholderText}
                onChange={onChange ? debounce(onChange, 100) : undefined}
                required={required}
                autoFocus={autoFocus}
                aria-labelledby={labelId}
            />
            {children}
        </>
    );
}
